import Vue from 'vue';

export default Vue.component('leave-site', {
  template: require('./template.html'),
  name: 'leave-site',
  data() {
    return {
      loading: false,
      ers: [],
    };
  },
  props: ['modal', 'active-site', 'toggle-modal'],
  methods: {
    leaveSite() {
      this.closeModal('leaveSite');
    },
    getSite() {
      return this.activeSite ? this.activeSite.alias : '';
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/account/profile/leave-site/index.js